export default __webpack_public_path__ + "static/media/miscellaneous23.bad50af0.png";